import { useEffect } from 'react';

import { toast } from 'sonner';

export const MAINTENANCE_TOAST_ID = 'maintenance-mode';
export const MAINTENANCE_TOASTER_ID = 'maintenance';

export const formatMaintenanceMessage = (message: string) => message.replace(/\\n/gim, ' ').replace(/\s+/g, ' ').trim();

const MaintenanceToast = () => {
  const message = import.meta.env['VITE_BETA_DISABLED_MESSAGE'] as string | undefined;

  useEffect(() => {
    if (!message) {
      return;
    }

    toast.warning('Maintenance', {
      id: MAINTENANCE_TOAST_ID,
      description: formatMaintenanceMessage(String(message)),
      duration: Infinity,
      closeButton: true,
      toasterId: MAINTENANCE_TOASTER_ID,
      classNames: {
        toast: 'border-1 border-primary-purple rounded-lg',
        content: 'flex min-w-0 flex-1 flex-col gap-0.5',
        title: 'text-primary-purple font-semibold uppercase text-lg',
        icon: 'text-primary-purple size-8 [&_svg]:size-full mr-2',
      },
    });
  }, [message]);

  return null;
};

MaintenanceToast.displayName = 'MaintenanceToast';

export default MaintenanceToast;
